<template>
	<el-table :data="tableData" border style="width: 100%">
		<el-table-column
			label="序号"
			align="center"
			width="50"
			type="index"
		></el-table-column>
		<el-table-column
			v-for="(item, index) in data.columnList"
			:key="index"
			:label="item.label"
			:prop="item.prop"
			align="center"
		>
			<template #default="scope" v-if="item.prop == 'isDelete'">
				{{ scope.row.isDelete == 0 ? "正常" : "停用" }}
			</template>
		</el-table-column>
		<el-table-column label="操作" align="center">
			<template #default="scope">
				<el-button
					type="primary"
					size="mini"
					@click="handleEdit(scope.row)"
					>编辑</el-button
				>
				<!-- <el-button
					type="danger"
					size="mini"
					@click="handleDelete(scope.row)"
					>删除</el-button
				> -->
			</template>
		</el-table-column>
	</el-table>

	<!-- 添加用户 -->
	<add-user
		ref="AddUserRef"
		scene="edit"
		:currentData="data.currentData"
	></add-user>
</template>

<script>
import { reactive, ref } from "@vue/reactivity";
import { ElMessageBox, ElMessage } from "element-plus";
import { apiSysUserDelete } from "@/api/requestApis.js";
import AddUser from "./children/add-user.vue";
import { inject } from "vue";
export default {
	props: {
		tableData: Array,
	},
	components: {
		AddUser,
	},
	setup() {
		const AddUserRef = ref(null);
		const handleSearch = inject("handleSearch");
		const data = reactive({
			currentData: {},
			columnList: [
				{
					label: "账户",
					prop: "userName",
				},
				{
					label: "姓名",
					prop: "chineseName",
				},
				{
					label: "状态",
					prop: "isDelete",
				},
				{
					label: "手机号",
					prop: "phone",
				},
				{
					label: "创建时间",
					prop: "createTime",
				},
			],
		});
		const handleEdit = (val) => {
			data.currentData = val;
			AddUserRef.value.handleToggle(true);
		};
		const handleDelete = (val) => {
			ElMessageBox.confirm("此操作将永久删除, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					await apiSysUserDelete({
						id: val.id,
					});
					handleSearch();
					ElMessage({
						type: "success",
						message: "删除成功!",
					});
				})
				.catch(() => {
					ElMessage({
						type: "info",
						message: "已取消删除",
					});
				});
		};
		return {
			AddUserRef,
			handleEdit,
			handleDelete,
			data,
		};
	},
};
</script>

<style  scoped>
</style>
